import { authRoutesNames } from '@/views/auth/auth.routes.ts'
import { spencerAdminRoutesNames } from '@/views/spencer-admin/spencer-admin.routes.ts'
import { schoolAdminRoutesNames } from '@/views/school-admin/schools-admin.routes.ts'
import { needManagerRoutesNames } from '@/views/need-manager/need-manager.routes'

import { settingsRouteNames } from '@/views/settings/settings.routes.ts'
import { uiKitRoutesNames } from '@/views/ui-kit/ui-kit.routes.ts'
import { professionalRoutesNames } from '@/views/professional/professional.routes'

import { studentsRouteNames } from '@/features/students/students.routes'

export const routeNames = {
  rootPage: 'rootPage',
  uiKit: 'ui-kit',

  spencerAdmin: 'spencer-admin',
  schoolAdmin: 'school-admin',
  needManager: 'need-manager',
  professional: 'professional',
  settings: 'settings',
  students: 'students',

  ...authRoutesNames,
  ...spencerAdminRoutesNames,
  ...schoolAdminRoutesNames,
  ...spencerAdminRoutesNames,
  ...needManagerRoutesNames,
  ...professionalRoutesNames,
  ...settingsRouteNames,
  ...uiKitRoutesNames,
  ...studentsRouteNames
}
